import { SET_AREAS_SUCCESS } from 'store/actionTypes/areas'

export const setDeliveryActionSuccess = (payload) => ({
  type: SET_AREAS_SUCCESS,
  payload,
})
